import { Pipe, PipeTransform } from '@angular/core';
import {
  formatIndianCompactCurrency,
  formatIndianCompactNumber,
} from '../utils/indian-compact-number';

@Pipe({ name: 'indianCompact', standalone: true })
export class IndianCompactPipe implements PipeTransform {
  transform(value: unknown, currency = false): string {
    return currency
      ? formatIndianCompactCurrency(value)
      : formatIndianCompactNumber(value);
  }
}
